import React, { Component } from 'react';
import { TextField } from '@shopify/polaris';

class InlineTextField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.text
    };
    this._handleFocusOut = this._handleFocusOut.bind(this);
  }

  _handleFocusOut(text) {
    const { id, description } = this.props.item;
    const status = { name: text, id: id, description: description };
    this.props.updateMethod(status);
  }

  render = () => {
    const { text, errors } = this.props;
    return (
      <TextField
        label="Name"
        value={text}
        onChange={this._handleFocusOut}
        error={errors?.[0]}
        customClassName="Header-Input-SOP"
      />
    );
  };
}

export default InlineTextField;
